<script setup>
  import { ref, onMounted, computed } from 'vue'
  import { useRouter, useRoute } from 'vue-router'
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  import Qrcode from 'vue-qrcode'
  import { useDialogStore } from '@/stores/dialogStore'
  import { useUserStore } from '@/stores/userStore'

  const router = useRouter()
  const route = useRoute()
  const query = route.query

  const dialogStore = useDialogStore()
  const userStore = useUserStore()

  const breadcrumbs = [{ name: 'ダッシュボード', url: 'dashboard' }, { name: 'ユーザーリスト', url: query.id ? `/user?id=${query.id}` : '/user' }, { name: 'ワンタイムパスワード' }]

  // 入力用の変数のみrefで定義
  const otpText = ref('')

  // QRコードテキストをcomputed propertyとして定義
  const qrCodeText = computed(() => {
    if (userStore.currentUser && userStore.otpSecret) {
      return `otpauth://totp/ディーモ:${userStore.currentUser.email}?secret=${userStore.otpSecret}&issuer=ディーモ`
    }
    return ''
  })

  // methods
  onMounted(async () => {
    await userStore.getCurrentUser()
    await userStore.getOtpData()
  })

  // OTP有効化処理
  const enableOtp = async () => {
    // 入力が数字6桁かどうかチェック
    if (!/^\d{6}$/.test(otpText.value)) {
      await dialogStore.showAlertDialog('エラー', '6桁の数字を入力してください。')
      return
    }

    // userStoreのenableOTP関数を呼び出す
    const message = await userStore.enableOTP(otpText.value)

    if (message) {
      await dialogStore.showMessageDialog('成功', 'ワンタイムパスワードを有効化しました。')

      // ユーザー編集画面へ戻る
      router.push({
        path: '/user',
        query: { id: userStore.currentUser?.id },
      })
    }
  }
</script>

<template>
  <Header />
  <main class="app-main">
    <div class="main-header">
      <h2>ワンタイムパスワード</h2>
    </div>
    <div class="main-body">
      <div class="onetime-content">
        <div class="step scroller">
          <div>
            <div class="num">01</div>
            <div class="img">
              <img class="logo" src="@/assets/img/google-authenticator.svg" />
            </div>
            <div class="txt">
              スマートフォンに
              <a href="https://apps.apple.com/jp/app/google-authenticator/id388497605" target="_blank">Google Authenticator</a>
              などのアプリをインストールしてください。このアプリでワンタイムパスワードを生成できます。
            </div>
          </div>
          <div>
            <div class="num">02</div>
            <div class="img">
              <qrcode :value="qrCodeText" :color="{ dark: '#000000', light: '#ffffff' }" type="image/png"></qrcode>
            </div>
            <div class="txt">アプリを開いて、QRコードを読み取って「CompanyAnalyzer」を追加登録してください。</div>
            <div class="secret-key" v-if="userStore.otpSecret">
              <!-- <p>手動設定用シークレットキー：</p>
              <code>{{ userStore.otpSecret }}</code> -->
            </div>
          </div>
          <div>
            <div class="num">03</div>
            <div class="txt">アプリに6桁の番号が表示されますので、その番号を下記に入力し、有効化してください。ワンタイムパスワードが有効になります。この後はログイン時に毎回この番号の入力が求められます。</div>
            <input type="text" v-model="otpText" maxlength="6" placeholder="000000" inputmode="numeric" />
            <button type="button" @click="enableOtp">有効化</button>
          </div>
        </div>
      </div>
    </div>
  </main>
  <Footer :breadcrumbs="breadcrumbs" />
</template>

<style lang="less" scoped></style>
